import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: colors.cyan.base,
                accent: colors.amber.base,
                error: colors.red.base,
                success: colors.lightGreen.base,
                text: colors.grey.darken3
            }
        }
    }
});
